module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-facebook-multi-pixels/gatsby-browser.js'),
      options: {"0":{"dev":false,"alias":"legacy","pixelId":"460388761115331","viewContent":false,"pageView":true},"1":{"dev":false,"alias":"media_sales","pixelId":"427259871161999","viewContent":false,"pageView":true},"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"London City Aiport - Media Sales","short_name":"LCY - Media Sales","start_url":"/","background_color":"#393e8c","theme_color":"#393e8c","display":"standalone","icon":"src/assets/images/favicon.svg","crossOrigin":"use-credentials","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","include_favicon":true,"cacheDigest":"0151d90c531d1fd5afce2a2745970325"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
